import Home from "../view/asHome/Home.svelte";

export const asHomeRoutes = {
    "/as_home/home": Home,
};